import type { TranslationKey } from './i18n';

export interface TierDefinition {
  key: string;
  labelKey: TranslationKey;
  featureKeys: TranslationKey[];
  color: string;
  bgColor: string;
}

export const TIERS: TierDefinition[] = [
  {
    key: 'free',
    labelKey: 'tier.free.label',
    featureKeys: ['tier.free.feature.seats', 'tier.free.feature.mcps', 'tier.free.feature.requests'],
    color: '#31679B',
    bgColor: '#e8f0f8',
  },
  {
    key: 'team',
    labelKey: 'tier.team.label',
    featureKeys: ['tier.team.feature.seats', 'tier.team.feature.mcps', 'tier.team.feature.requests'],
    color: '#00734D',
    bgColor: '#e6f4ef',
  },
  {
    key: 'enterprise',
    labelKey: 'tier.enterprise.label',
    featureKeys: ['tier.enterprise.feature.seats', 'tier.enterprise.feature.mcps', 'tier.enterprise.feature.chat'],
    color: '#18181b',
    bgColor: '#f4f4f5',
  },
];

export const METHOD_COLORS: Record<string, { bg: string; text: string }> = {
  GET: { bg: '#e8f5ef', text: '#007347' },
  POST: { bg: '#f0f4f8', text: '#2C4A69' },
  PUT: { bg: '#fff7ed', text: '#b04020' },
  DELETE: { bg: '#fef2f2', text: '#C24242' },
  PATCH: { bg: '#fffbeb', text: '#92400e' },
};

export const ACCESS_STATUS_CONFIG: Record<string, { dotColor: string; bgColor: string; textColor: string }> = {
  full_access: {
    dotColor: '#007347',
    bgColor: '#e8f5ef',
    textColor: '#007347',
  },
  org_linked_no_user: {
    dotColor: '#E86E44',
    bgColor: '#fff7ed',
    textColor: '#b04020',
  },
  not_linked: {
    dotColor: '#a1a1aa',
    bgColor: '#f4f4f5',
    textColor: '#71717a',
  },
  request_pending: {
    dotColor: '#2C4A69',
    bgColor: '#f0f4f8',
    textColor: '#2C4A69',
  },
  instant_available: {
    dotColor: '#007347',
    bgColor: '#e8f5ef',
    textColor: '#007347',
  },
  active: {
    dotColor: '#007347',
    bgColor: '#e8f5ef',
    textColor: '#007347',
  },
};

export const REQUEST_STATUS_CONFIG: Record<string, { labelKey: TranslationKey; dotColor: string; bgColor: string; textColor: string }> = {
  pending: { labelKey: 'requestStatus.pending', dotColor: '#E86E44', bgColor: '#fff7ed', textColor: '#b04020' },
  approved: { labelKey: 'requestStatus.approved', dotColor: '#007347', bgColor: '#e8f5ef', textColor: '#007347' },
  denied: { labelKey: 'requestStatus.denied', dotColor: '#C24242', bgColor: '#fef2f2', textColor: '#C24242' },
  cancelled: { labelKey: 'requestStatus.cancelled', dotColor: '#71717a', bgColor: '#f4f4f5', textColor: '#71717a' },
};

export const TIER_LABEL_KEYS: Record<string, TranslationKey> = {
  free: 'tierLabel.free',
  team: 'tierLabel.team',
  enterprise: 'tierLabel.enterprise',
};

// 'organization' scope adds org membership claims; 'beheerder' role is added at signup via realm_access.roles, not via a scope.
export function getAuthScope(): string {
  return 'openid profile email organization';
}
